export default {
  namespaced: true,

  state: {
    downloading: false,
    query: {
      updatedDate: '',
      budgetLower: '',
      budgetUpper: '',
      budgetTerm: '',
      corporateName: '',
      cityCd: [],
      establishedYear: '',
      industryCd: [],
      keyword: '',
      prPointCd: [],
      published: '',
      publishedRecruitMediaCd: [],
      publishedRecruitMediaTerm: '',
      publishedTerm: '',
      publishedRecruitOrAp: '',
      stationId: '',
      stationName: '',
      excludedNoCorporateTel: 'false',
      excludedNoCorporateUrl: 'false',
      order: '',
    },
  },
  getters: {
    apiQuery: state =>
      ({
        updatedDate: state.query.updatedDate,
        budgetLower: state.query.budgetLower,
        budgetUpper: state.query.budgetUpper,
        budgetTerm: state.query.budgetTerm,
        corporateName: state.query.corporateName,
        cityCd: state.query.cityCd.map(p => (p.value || p)).join(','),
        establishedYear: state.query.establishedYear,
        industryCd: state.query.industryCd.map(i => (i.value || i)).join(','),
        keyword: state.query.keyword,
        prPointCd: state.query.prPointCd.join(','),
        published: state.query.published,
        publishedRecruitMediaCd: state.query.publishedRecruitMediaCd.map(pp =>
          (pp.value || pp)).join(','),
        publishedRecruitMediaTerm: state.query.publishedRecruitMediaTerm,
        publishedTerm: state.query.publishedTerm,
        publishedRecruitOrAp: state.query.publishedRecruitOrAp,
        stationId: state.query.stationId,
        // stationNameはstationIdがあるので除外
        excludedNoCorporateTel: state.query.excludedNoCorporateTel,
        excludedNoCorporateUrl: state.query.excludedNoCorporateUrl,
        order: state.query.order,
      })
    ,
  },
  mutations: {
    updatedDate: (state, value) => state.query.updatedDate = value,
    budgetLower: (state, value) => state.query.budgetLower = value,
    budgetUpper: (state, value) => state.query.budgetUpper = value,
    budgetTerm: (state, value) => state.query.budgetTerm = value,
    corporateName: (state, value) => state.query.corporateName = value,
    cityCd: (state, value) => state.query.cityCd = value,
    establishedYear: (state, value) => state.query.establishedYear = value,
    industryCd: (state, value) => state.query.industryCd = value,
    keyword: (state, value) => state.query.keyword = value,
    prPointCd: (state, value) => state.query.prPointCd = value,
    published: (state, value) => state.query.published = value,
    publishedRecruitMediaCd: (state, value) => state.query.publishedRecruitMediaCd = value,
    publishedRecruitMediaTerm: (state, value) => state.query.publishedRecruitMediaTerm = value,
    publishedTerm: (state, value) => state.query.publishedTerm = value,
    publishedRecruitOrAp: (state, value) => state.query.publishedRecruitOrAp = value,
    stationId: (state, value) => state.query.stationId = value,
    stationName: (state, value) => state.query.stationName = value,
    excludedNoCorporateTel: (state, value) => state.query.excludedNoCorporateTel = value,
    excludedNoCorporateUrl: (state, value) => state.query.excludedNoCorporateUrl = value,
    order: (state, value) => state.query.order = value,
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/searchCorporation.js